
$(window).on('load', function () {
    let timerId;
    const debounce = (fn, delay) => {
        clearTimeout(timerId);
        timerId  =  setTimeout(fn, delay);
    }
    window.addMasks(document, '.js-input-tel-');
    $('body').on('click', '.default_address', function () {
        check_default_address(this);
    });
    $('body').on('submit', '.order_stop_form', function () {
        return check_order_stop_form(this);
    });
    $('body').on('input', '.prolong_my_days', function () {
        return check_prolong(this);
    });
    $('body').on('submit', '.profile_prolong_form', function () {
        return send_prolong(this);
    });
    $('body').on('submit', '.profile_prolong_as_sub_form', function () {
        return send_prolong_as_sub(this);
    });
    $('body').on('click', '.prolong_popup_link', function () {
        return send_prolong_as_sub($(this).parents('.profile_prolong_as_sub_form'));
    });
    $('body').on('click', '.prolong_sub_agreed', function () {

        if ($(this).prop('checked') == true) {
            $(this).parent().find('span').removeClass('is-error');
        } else {
            $(this).parent().find('span').addClass('is-error');
        }
    });

    $('body').on('click', '.confirm_sub_prolong', function () {
        var service_id = $(this).find('.service_id').val();
        $('.profile_prolong_as_sub_form_' + service_id).submit();
    });

    $('body').on('input', '.login_username', function (e) {
        debounce(() => login_by_phone(this), 300);
    });
    $('body').on('click', '.login_phone_button', function () {
        send_phone_login_code(this);
    });
    $('body').on('click', '.check_login_phone_button', function () {
        check_phone_authorization_code(this);
    });
    $('body').on('focus', '.check_login_phone_field', function () {
        window.ready_field(this);
    });
    $('body').on('click', '.profile_order_delete', function () {
        return profile_order_delete(this);
    });
    $('body').on('click', '.estimate_link', function () {
        estimate_order(this);
    });
    $('body').on('click', '.profile-order-checkbox.partial_return', function () {
        check_partial_return_checkbox();
    });


    $('body').on('click', '.js-order-items-select', function () {
        var data_order = $(this).attr('data-order');
		//console.log(data_order);
        $('.checkbox-' + data_order).each(function () {
            $(this).addClass('partial_return');
            $(this).parents('.order-table__i-box').addClass('has-checkbox');
        });
        $('.full-return-' + data_order).addClass('nod');
        //$('.partial-return-'+data_order).removeClass('nod');
        check_partial_return_checkbox();
        return false;
    });


    $('body').on('input', '.check_login_phone_field', function () {
        var val = $(this).val();

        //console.log(val);
        if (val.length == 6) {
            $(this).parents('.inputbox').find('.check_login_phone_button').click();
        }

    });

    $('body').on('click', '.profile_prolong_form .days_list', function () {
        var val = $(this).find('.field').val();
        $(this).parents('.profile_prolong_form').find('.day_count').val(val);
    });

    login_by_phone();
    if ($('.profile-order-checkbox').length > 0) {
        $('.order-table__checkbox').removeClass('nod');
        //$('.user-orders__cancel').removeClass('nod');
    }

    $('body').on('click', '.js-subs-cont-toggle', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-open').closest('.order-table__i-box').find('.order-table__subs-dd').slideToggle();
    });

    $('body').on('change', '.profile_bill_date', function () {
        if ($(this).hasClass('date_start')) {
            window.setCookie('profile_bill_date_start', $(this).val());
        }
        if ($(this).hasClass('date_end')) {
            window.setCookie('profile_bill_date_end', $(this).val());
        }
        window.location.reload();
    });

    $('body').on('change', '.profile_card_history_date', function () {
        if ($(this).hasClass('date_end')) {
            return;
        }
        const start = $('.profile_card_history_date.date_start').val();
        const end = $('.profile_card_history_date.date_end').val();
        const addr = `/profile/cards/history/?date_start=${start}&date_end=${end}`;
        window.location.href = addr;
        //window.location.reload();
    });
    formProcessor($('.popup-rent-finish')[0]).init({
        processElements: ['deliveryType', 'deliveryDate', 'deliveryVariant'],
        allElements: ['deliveryType', 'deliveryDate', 'deliveryVariant', 'comment', 'deliveryTime', 'address', 'address_id', 'pickup_pvz', 'bigShipment', 'order_id', 'posId'],
    });

    const dropzoneElement = document.querySelector('.order-image-upload');
    if (dropzoneElement) {
        const delayedFns = [];
        const ticket_id = dropzoneElement.dataset.id;
        dropzoneElement.classList.add('dropzone');

        new Dropzone(".order-image-upload", {
            url: '/profile/images/'+ticket_id+'/',
            method: 'post',
            paramName: 'file',
            maxFilesize: 20,
            maxFiles: 3,
            acceptedFiles: 'image/*',
            addRemoveLinks: true,
            uploadMultiple: true,
            parallelUploads: 1,
            resizeWidth: 1920,
            resizeHeight: 1920,
            dictDefaultMessage: "Перетащите файлы или нажмите для выбора...",
            dictInvalidFileType: 'К сожалению мы можем принять только фотографию.',
            dictFileTooBig: 'Файл слишком большой, мы можем принять файл размером не более 20 мегабайт.',
            dictMaxFilesExceeded: 'Нам достаточно одного изображения. Спасибо!',
            dictCancelUpload: 'Отменить загрузку',
            dictRemoveFile: '',
            success: function(file, response) {
                if (response.status === 'Fail') {
                    this.removeFile(file);
                } else {
                    delayedFns.push(async () => {
                        const result = await swal.fire({
                            title: "Добавить комментарий?",
                            input: 'textarea',
                            html: `Загруженное фото<br><img src="${response.www}" width="100" />`,
                            inputPlaceholder: "Введите текст (необязательно)",
                            inputValue: '',
                            showCancelButton: true,
                            confirmButtonColor: "#5cb85c",
                            confirmButtonText: "Добавить",
                            cancelButtonText: "Без комментария",
                            closeOnConfirm: false,
                        });
                        if (result.value) {
                            const formData = new FormData();
                            formData.append('comment', result.value);
                            formData.append('id', response.id);
                            const changeRequest = await fetch(`/profile/image/${ticket_id}/`, { method: 'POST', body: formData });
                            if (!changeRequest.ok) {
                                return;
                            }
                        }
                    });
                }
            },
            queuecomplete: async function(file, response) {
                $('.popup-image-upload').hide();
                for (const fn of delayedFns) {
                    await fn();
                }
                document.location.reload();
            },
            error: function(file, response) {
                this.removeFile(file);
            }
        });

    }
});

const formProcessor = (element) => ({
    element,
    processElements: [],
    allElements: [],
    init: function(config = {}) {
        if (config.formElement) {
            this.element = config.formElement;
        }
        if (config.processElements) {
            this.processElements = config.processElements;
        }
        if (config.allElements) {
            this.allElements = config.allElements;
        }
        const form = $(this.element);
        const processor = this;
        const inputs = form.find('input,select');
        Array.from(inputs).forEach((input) => {
            const fn = async function(event) {
                await processor.update($(event.target));
            };
            $(input).off('input').on('input', fn);
            $(input).off('change').on('change', fn);
        });
        const formElem = form.find('form');
        formElem.off('submit').on('submit', function(e) {
            e.preventDefault();
            const values = {};
            const invalidFields = [];
            const inputs = form.find('input,select');
            const valid = processor.allElements.reduce((acc, name) => {
                let foundInputs = Array.from(inputs.filter(`[name="${name}"]`));
                if (values.deliveryType !== 'pos' && name === 'posId') {
                    return acc;
                }
                if (!foundInputs.length) {
                    invalidFields.push(name);
                    return false;
                }
                if (foundInputs.length > 1) {
                    foundInputs = foundInputs.filter((inp) => inp.type !== 'radio' || inp.checked);
                }
                if (foundInputs.length > 1 && name === 'deliveryDate') {
                    if (values.deliveryType === 'pvz') {
                        foundInputs[0].disabled = true;
                    } else {
                        foundInputs[1].disabled = true;
                    }
                    foundInputs = values.deliveryType === 'pvz' ? [foundInputs[1]] : [foundInputs[0]];
                }
                const [input] = foundInputs;
                values[name] = input.value;
                if (!acc) {
                    return acc;
                }
                const fieldsByDeliveryType = {
                    pvz: ['deliveryType', 'deliveryDate', 'pickup_pvz', 'order_id'],
                    courier: ['deliveryType', 'deliveryDate', 'deliveryVariant', 'deliveryTime', 'order_id'],
                    pos: ['deliveryType', 'posId', 'order_id'],
                }
                const requiredFields = fieldsByDeliveryType[values.deliveryType];
                if (requiredFields.includes(name) && !values[name]) {
                    invalidFields.push(name);
                    return false;
                }
                if (values.deliveryType === 'courier' && name === 'address_id') {
                    invalidFields.push('address');
                    return Boolean(values.address || values.address_id);
                }
                if (name === 'posId' && !$('[data-pos-message]').data('is-ready')) {
                    invalidFields.push('posId');
                    return false;
                }
                return acc;
            }, true);
            if (!valid) {
                invalidFields.forEach((fieldName) => {
                    const currentInputs = inputs.filter(`[name="${fieldName}"]`);
                    currentInputs.addClass('is-error');
                    currentInputs.closest('.selectbox').find('.selectbox__btn').addClass('is-error');
                    currentInputs.closest('.select').find('.select-styled').addClass('is-error');
                    currentInputs.one('change', () => {
                        currentInputs.removeClass('is-error');
                        currentInputs.closest('.selectbox').find('.selectbox__btn').removeClass('is-error');
                        currentInputs.closest('.select').find('.select-styled').removeClass('is-error');
                    })
                });
                Array.from(inputs).forEach((input) => {
                    input.disabled = false;
                });
            } else {
                Array.from($(this).find('button[type="submit"]')).forEach((input) => {
                    input.disabled = true;
                    input.querySelector('span').innerHTML = '<img src="/assets/images/loader.gif" class="loader">';
                });
                $('.checkout-radio').addClass('disabled');
                $('.checkout-tabs').addClass('disabled');
                this.submit();
            }
        })
    },
    update: async function(element) {
        if (element.attr('name') === 'posId') {
            const readyValue = $(`[data-pos-id="${element.val()}"]`);
            $('[data-pos-message]').html(readyValue.data('pos-ready') ? 'Есть свободные ячейки для возврата' : 'На данный момент нет свободных ячеек в постамате, попробуйте позже');
            if (readyValue.data('pos-ready')) {
                $('[data-pos-message]').removeClass('_error');
                $('[data-pos-message]').data('is-ready', 1);
            } else {
                $('[data-pos-message]').addClass('_error');
                $('[data-pos-message]').data('is-ready', 0);
            }
        }
        if (!this.processElements.includes(element.attr('name'))) {
            return;
        }
        const form = $(this.element);
        const inputs = form.find('input,select');
        Array.from(inputs).forEach((input) => {
            input.readOnly = true;
        });
        const data = new FormData();
        this.allElements.forEach((name) => {
            let foundInputs = Array.from(inputs.filter(`[name="${name}"]`));
            if (!foundInputs.length) {
                return;
            }
            if (foundInputs.length > 1) {
                foundInputs = foundInputs.filter((inp) => inp.type !== 'radio' || inp.checked);
            }
            if (foundInputs.length > 1 && name === 'deliveryDate') {
                foundInputs = data.get('deliveryType') === 'pvz' ? [foundInputs[1]] : [foundInputs[0]];
            }
            const [input] = foundInputs;
            const val = input.value;
            data.append(name, val);
        });
        const response = await fetch('/api/return/', { method: 'POST', body: data });
        Array.from(inputs).forEach((input) => {
            input.readOnly = false;
        });
        if (!response.ok) {
            return;
        }
        const result = await response.json();

        const deliveryVariants = $('[data-delivery-variant]');
        const variantsHtml = result.deliveryVariants.map((oneVariant) => `
            <div class="selectbox__dd-i js-selectbox-select">
                <input type="hidden" value="${oneVariant.id}">
                <div class="selectbox__val">${oneVariant.name}</div>
                <div class="selectbox__price">${oneVariant.price ? oneVariant.price + ' <span class="rub">c</span>' : 'Бесплатно'}</div>
            </div>
        `).join('');
        deliveryVariants.find('.selectbox__val').html(result.currentVariant.name);
        deliveryVariants.find('.selectbox__price').html(result.currentVariant.price ? result.currentVariant.price + ' <span class="rub">c</span>' : 'Бесплатно');
        deliveryVariants.find('input').val(result.currentVariant.id);
        deliveryVariants.find('.selectbox__dd').html(variantsHtml);

        const deliveryTimes = $('[data-delivery-time]').closest('.select');
        const timesHtml = result.deliveryTimes.map((time) => `
            <option value="${time === 'Недоступно' ? '' : time}" ${time === result.currentTime ? 'selected' : ''}>
                ${time}
            </option>
        `).join('');
        deliveryTimes.replaceWith(`<select class="selectstyle" name="deliveryTime" data-delivery-time>${timesHtml}</select>`);
        window.update_select_style($('[data-delivery-time]'));

        const priceBlock = $('[data-price-courier]');
        priceBlock.html(result.cheapest ? `от ${result.cheapest} ₽` : '<strong>Бесплатно</strong>');
    },
});

const firstRecovery = (e) => {
    e.preventDefault();
    activate_phone(e.target);
    return false;
};
const secondRecovery = (e) => {
    e.preventDefault();
    activate_phone_code(e.target);
    return false;
};
const finishRecovery = (e) => {
    e.preventDefault();
    change_pass(e.target);
    return false;
};
const recoveryButton = document.querySelector('.recovery_button');

document.addEventListener('DOMContentLoaded', () => {
    if (recoveryButton) {
        recoveryButton.addEventListener('click', firstRecovery);
    }
})

function check_partial_return_checkbox() {
    $('.profile-order-checkbox.partial_return').each(function () {
        var wrapper = $(this).parents('.profile_order_wrapper');
        if (wrapper) {

            var order_number = $(wrapper).find('.order_number').val();
            if (order_number) {

                $('.partial-return-order-' + order_number).addClass('nod');
                var action_service_link = $('a.partial-return-order-' + order_number);
                var action_service_list = $(action_service_link).find('input[name="service_list"]');

                if (action_service_list) {
                    var service_list = [];
                    var i = 0;
                    $(wrapper).find('.checkbox-order-' + order_number).each(function () {
                        if ($(this).prop('checked')) {
                            service_list[i] = $(this).val();
                            i++;
                        }
                    });

                    if (service_list.length == 0) {
                        $(action_service_list).val('');
                    }
                    if (service_list.length > 0) {
                        $(action_service_list).val(service_list.join(','));
                        $('.partial-return-order-' + order_number).removeClass('nod');
                    }
                }
            }
        }
    });
}

function estimate_order(elem) {
    if (elem) {
        var wrapper = $(elem).parents('.profile_estimate_form');
        var url = $(wrapper).attr('action');
        var data = new Object();
        data.number = $(elem).find('.number').val();

        var ajax_obj = {
            url: url,
            type: 'post',
            beforeSend: function () {
                $(wrapper).find('.loader_wrapper').removeClass('nod');
                $(wrapper).find('.field_wrapper').addClass('nod');
            },
            data: data,
            dataType: 'json',
            complete: function (answer) {
                $(wrapper).find('.loader_wrapper').addClass('nod');

                if (answer.responseText) {
                    try {
                        res = $.parseJSON(answer.responseText);
                    } catch (err) {
                        res = new Object();
                    }
                    if (res.message) {
                        $(wrapper).find('.result_wrapper').html(res.message);
                    }
                    if (res.order_id) {
                        $('.estimate_button_' + res.order_id).remove();
                    }
                    if (res.result == 0) {
                        $(wrapper).find('.result_wrapper').addClass('error_color');
                    }
                    if (res.result == 1) {
                        $(wrapper).find('.result_wrapper').addClass('good_color');

                    }
                }
            },
            cache: false,
            async: true,
        };
        $.ajax(ajax_obj);
    }
    return false;
}

function profile_order_delete(elem) {

    if (elem) {

        var url = $(elem).attr('href');

        var ajax_obj = {
            url: url,
            type: 'post',
            beforeSend: function () {
                $(elem).find('.loader_wrapper').removeClass('nod');
                $(elem).find('.field_wrapper').addClass('nod');
            },
            dataType: 'json',
            complete: function (data) {
                $(elem).find('.loader_wrapper').addClass('nod');

                if (data.responseText) {
                    try {
                        res = $.parseJSON(data.responseText);
                    } catch (err) {
                        res = new Object();
                    }

                    $(elem).parent().find('.js-popup-close').click();

                    if (res.order_id) {
                        $('.order_wrapper_' + res.order_id).remove();
                    }
                    return false;
                }
            },
            cache: false,
            async: true,
        };
        $.ajax(ajax_obj);
    }
    return false;
}


function check_phone_authorization_code(elem) {
    if (elem) {
        var wrapper = $(elem).parents('.inputbox');
        var is_ok = check_field($(wrapper).find('.check_login_phone_field'), 1);

        if (is_ok) {
            var input = $(wrapper).find('.check_login_phone_field');
            var data = { code: $(input).val(), username: $(wrapper).find('.login_username').val() };

            var ajax_obj = {
                url: '/login/code/',
                type: 'post',
                beforeSend: function () {
                    $(elem).addClass('nod');
                    $(wrapper).find('.alert-error').addClass('nod').val('');
                    $(wrapper).find('.is-wait').removeClass('nod');
                    $(wrapper).find('.is-process').addClass('nod');
                },
                data: data,
                dataType: 'json',
                complete: function (data) {
                    if (data.responseText) {
                        //console.log(data.responseText);
                        res = eval('(' + data.responseText + ')');
                        $(wrapper).find('.is-wait').addClass('nod');
                        if (res.result == 1) {
                            $(wrapper).find('.alert-error').addClass('nod').val('');
                            $(wrapper).find('.phone_counter').html(0);
                            $(wrapper).find('.phone_counter').parent().addClass('nod');
                            $(wrapper).find('.is-begin').addClass('nod');
                            $(wrapper).find('.is-process').addClass('nod');
                            if (res.message) {
                                $(wrapper).find('.alert-success').html(res.message);
                            }
                            //if (res.mail) {$(contact_wrapper).find('.mail_field').val(res.mail);}
                            if ($(input).hasClass('need_auth')) {
                                window.location.href = '/profile/orders/';
                            }
                            //if ($(input).hasClass('need_auth')) {$('#cart_list_form').submit();}

                            //save_cart_user_info();
                        } else if (res.result == 0) {
                            $(wrapper).find('.is-process').removeClass('nod');
                            if (res.error) {
                                $(wrapper).find('.alert-error').html(res.error).removeClass('nod');
                            }
                            //if ($(input).hasClass('need_auth')) {window.location.reload();}
                        }
                    }
                },
                cache: false,
                async: true,
            };

            $.ajax(ajax_obj);
        }
    }
}

function send_phone_login_code(elem) {
    if (elem) {
        var container = $('#profile_login_form');
        if (elem) {
            container = $(elem).parents('form');
        }
        var wrapper = $(elem).parents('.inputbox');
        var data = { username: $(wrapper).find('.login_username').val(), initiator: 'profile_phone_authorization' };

        var ajax_obj = {
            url: '/login/sms/',
            type: 'post',
            beforeSend: function () {
                $(elem).addClass('nod');
                $(wrapper).find('.is-wait').removeClass('nod');
                $(wrapper).find('.inputbox__error').html('');
                $(wrapper).find('.is-begin').addClass('nod');
                $(wrapper).find('.inputbox__input').removeClass('is-error');
            },
            data: data,
            dataType: 'json',
            complete: function (data) {
                if (data.responseText) {

                    res = eval('(' + data.responseText + ')');
                    if (res.result == 1) {
                        $(wrapper).find('.is-wait').addClass('nod');
                        $(wrapper).find('.is-begin').addClass('nod');
                        $(wrapper).find('.is-process').removeClass('nod');
                        if (res.message) {
                            $(wrapper).find('.alert-success').html(res.message);
                        }
                        if (res.error) {
                            $(wrapper).find('.alert-error').html(res.error);
                        }
                    }

                    if (res.result == 0) {
                        $(wrapper).find('.is-wait').addClass('nod');
                        $(wrapper).find('.is-process').addClass('nod');
                        $(wrapper).find('.is-begin').removeClass('nod');
                        if (res.error) {
                            $(wrapper).find('.alert-error').html(res.error);
                        }
                    }
                    if (res.is_counter) {
                        $('.login_phone_button').addClass('nod');
                        var counter = $('.phone_counter');
                        if (parseInt($(counter).html()) > 0) {
                            set_counter(counter);
                        }
                    }
                }
            },
            cache: false,
            async: true,
        };

        $.ajax(ajax_obj);
    }
}

const set_recovery_counter = (elem) => {
    if (!elem) {
        return;
    }

    const wrapper = $(elem).parents('form');
    const new_number = parseInt($(elem).html()) - 1;
    if (new_number < 0) {
        $(elem).parent().html('');
        $(wrapper).find('.recovery_button').removeClass('is_disabled').attr('disabled', false);
    } else {
        $(elem).html(new_number);
        setTimeout(set_recovery_counter, 1000, elem);
        $(wrapper).find('.recovery_button').addClass('is_disabled').attr('disabled', true);
    }
}

const createLoader = () => {
    const loader = document.createElement('div');
    const styles = { width: '100%', position: 'absolute', height: '100%', top: 0, left: 0, background: 'rgba(0,0,0,0.1)' };
    Object.entries(styles).forEach(([name, value]) => loader.style[name] = value);
    loader.innerHTML = `<div class="login_loader cent" style="top: 50%; position: absolute; left: 50%; transform: translate3d(-50%, -50%, 0);">
        <img src="/assets/images/loader.gif" class="loader">
    </div>`;
    return loader;
}

const activate_phone = (elem) => {
    if (!elem) {
        return;
    }
    const container = $(elem).parents('form');
    var wrapper = $(container).find('[name="phone"]').parents('.inputbox');
    var data = { phone: $(container).find('[name="phone"]').val() };
    const loader = createLoader();

    document.querySelector('.password').style.position = 'relative';

    var ajax_obj = {
        url: '/login/recovery/find/',
        type: 'post',
        beforeSend: function () {
            $(elem).attr('disabled', true);
            $(wrapper).find('.is-wait').removeClass('nod');
            $(wrapper).find('.inputbox__error').html('');
            $(wrapper).find('.is-begin').addClass('nod');
            $(wrapper).find('.inputbox__input').removeClass('is-error');
            $(wrapper).find('.alert-error').html('');
            $('.password').append(loader);
        },
        data: data,
        dataType: 'json',
        complete: function (data) {
            $(elem).attr('disabled', false);
            loader.remove();
            if (data.responseText) {
                const res = JSON.parse(data.responseText);
                if (res.result == 1) {
                    $('.password__desc').html('Введите код, высланный на телефон');
                    container.find('label').html('Код из СМС<strong>*</strong>');
                    const inp = document.createElement('input');
                    inp.type = 'password';
                    inp.name = 'code';
                    inp.classList.add('inputbox__input');

                    const passToggle = document.createElement('div');
                    passToggle.classList.add('inputbox__icon','js-pass-toggle');
                    passToggle.innerHTML = `<svg class="icon icon-eye-open">
                          <use xlink:href="/assets/images/sprite.svg#eye-open"></use>
                        </svg>
                        <svg class="icon icon-eye-close">
                          <use xlink:href="/assets/images/sprite.svg#eye-close"></use>
                        </svg>`;

                    wrapper.find('.inputbox__field').find('input').addClass('nod').attr('readonly', true);

                    wrapper.find('.inputbox__field').append(inp);
                    wrapper.find('.inputbox__field').append(passToggle);

                    container.find('.recovery_button').find('span').text('Подтвердить');
                    recoveryButton.removeEventListener('click', firstRecovery);
                    recoveryButton.addEventListener('click', secondRecovery);
                }

                if (res.result == 0) {
                    $(wrapper).find('.inputbox__input').addClass('is-error');
                    if (res.error) {
                        $(wrapper).find('.alert-error').html(res.error);
                    }
                }

                if (res.is_counter) {
                    $(elem).attr('disabled', true);
                    var counter = $('.phone_counter');
                    if (parseInt($(counter).html()) > 0) {
                        set_recovery_counter(counter);
                    }
                }
            }
        },
        cache: false,
        async: true,
    };

    $.ajax(ajax_obj);
};

const activate_phone_code = (elem) => {
    if (!elem) {
        return;
    }
    const container = $(elem).parents('form');
    var wrapper = $(container).find('[name="code"]').parents('.inputbox');
    var data = { code: $(container).find('[name="code"]').val(), username: $(container).find('[name="phone"]').val() };
    const loader = createLoader();

    var ajax_obj = {
        url: '/login/recovery/code/',
        type: 'post',
        beforeSend: function () {
            $(elem).attr('disabled', true);
            $(wrapper).find('.is-wait').removeClass('nod');
            $(wrapper).find('.inputbox__error').html('');
            $(wrapper).find('.is-begin').addClass('nod');
            $(wrapper).find('.inputbox__input').removeClass('is-error');
            $(wrapper).find('.alert-error').html('');
            $('.password').append(loader);
        },
        data: data,
        dataType: 'json',
        complete: function (data) {
            $(elem).attr('disabled', false);
            loader.remove();
            if (data.responseText) {
                const res = JSON.parse(data.responseText);
                if (res.result == 1) {
                    $('.page__title span').text('Укажите ваш новый пароль');
                    $('.password__desc').html('Минимум 6 символов, одна цифра и одна буква обязательны');
                    $(container).find('.inputbox').addClass('nod');
                    const newInput = document.createElement('div');
                    newInput.classList.add('inputbox','inputbox--pass');
                    newInput.innerHTML = `<label>пароль<strong>*</strong></label>
                    <div class="inputbox__field">
                      <input class="inputbox__input" name="password" type="password">
                      <div class="inputbox__icon js-pass-toggle">
                        <svg class="icon icon-eye-open">
                          <use xlink:href="/assets/images/sprite.svg#eye-open"></use>
                        </svg>
                        <svg class="icon icon-eye-close">
                          <use xlink:href="/assets/images/sprite.svg#eye-close"></use>
                        </svg>
                      </div>
                    </div>`;
                    const newInputRepeat = document.createElement('div');
                    newInputRepeat.classList.add('inputbox','inputbox--pass');
                    newInputRepeat.innerHTML = `<label>подтверждение пароля<strong>*</strong></label>
                    <div class="inputbox__field">
                      <input class="inputbox__input" name="password_repeat" type="password">
                      <div class="inputbox__icon js-pass-toggle">
                        <svg class="icon icon-eye-open">
                          <use xlink:href="/assets/images/sprite.svg#eye-open"></use>
                        </svg>
                        <svg class="icon icon-eye-close">
                          <use xlink:href="/assets/images/sprite.svg#eye-close"></use>
                        </svg>
                      </div>
                    </div>`;

                    container.append(newInput);
                    container.append(newInputRepeat);

                    const errorNew = document.createElement('div');
                    errorNew.classList.add('inputbox__error', 'alert-error');
                    newInputRepeat.append(errorNew);

                    const btn = container.find('.recovery_button');
                    btn.find('span').text('Сменить пароль');
                    const newButton = btn.clone(true);
                    container.append(newButton);
                    recoveryButton.removeEventListener('click', secondRecovery);
                    newButton[0].addEventListener('click', finishRecovery);
                }

                if (res.result == 0) {
                    $(wrapper).find('.inputbox__input').addClass('is-error');
                    if (res.error) {
                        $(wrapper).find('.alert-error').html(res.error);
                    }
                }
            }
        },
        cache: false,
        async: true,
    };

    $.ajax(ajax_obj);
};

const change_pass = (elem) => {
    if (!elem) {
        return;
    }
    const container = $(elem).parents('form');
    var wrapper = $(container).find('[name="code"]').parents('.inputbox');
    var data = {
        code: $(container).find('[name="code"]').val(),
        username: $(container).find('[name="phone"]').val(),
        password: $(container).find('[name="password"]').val(),
        password_repeat: $(container).find('[name="password_repeat"]').val(),
    };
    const loader = createLoader();

    var ajax_obj = {
        url: '/login/recovery/change/',
        type: 'post',
        beforeSend: function () {
            $(elem).attr('disabled', true);
            $(wrapper).find('.is-wait').removeClass('nod');
            $(wrapper).find('.inputbox__error').html('');
            $(wrapper).find('.is-begin').addClass('nod');
            $(wrapper).find('.inputbox__input').removeClass('is-error');
            $(wrapper).find('.alert-error').html('');
            $('.password').append(loader);
        },
        data: data,
        dataType: 'json',
        complete: function (data) {
            $(elem).attr('disabled', false);
            loader.remove();
            if (data.responseText) {
                const res = JSON.parse(data.responseText);
                if (res.result == 1) {
                    $('.page__title span').text('Пароль изменен');
                    $('.password__desc').html(`Мы отправили уведомление на вашу почту.
                        <br>Теперь вы можете
                        <a href="/login/">войти в личный кабинет</a>
                        с новым паролем.`
                    );
                    $(container).find('.inputbox').addClass('nod');
                    $('.recovery_button').remove();
                }

                if (res.result == 0) {
                    $(container).find('.inputbox__input').addClass('is-error');
                    if (res.error) {
                        $(container).find('.alert-error').html(res.error);
                    }
                }
            }
        },
        cache: false,
        async: true,
    };

    $.ajax(ajax_obj);
};


const cache = {};
function login_by_phone(elem) {
    var container = $('#profile_login_form');
    if (elem) {
        container = $(elem).parents('form');
    }
    if (container) {
        let data = {
            partner: $(document).find('.partner').val(),
            h: $(document).find('.cart_token').val(),
        };
        data = Object.values(data).filter((e) => e).length > 0 ? data : {};

        $(container).find('.login_username').each(function () {
            data[$(this).attr('name')] = $(this).val();
        });

        const updateForms = (res) => {
            if (res.person_phone_block_button_html) {
                $(container).find('.phone_block_wrapper').find('.button_in_phone').html(res.person_phone_block_button_html).removeClass('nod');
            }
            const addedChar = res.person_phone_block_comment_html ?? '';
            $(container).find('.phone_block_wrapper').find('.added_charact').html(addedChar);
        }

        var ajax_obj = {
            url: '/login/check/',
            type: 'post',
            beforeSend: function () {
                $(container).find('.phone_block_wrapper').find('.added_charact').html('');
                $(container).find('.phone_block_wrapper').find('.button_in_phone').addClass('nod');
                $(container).find('.phone_block_wrapper').find('.button_in_phone').html('');
                $(container).find('.phone_block_wrapper').find('.login_loader').removeClass('nod');
            },
            data,
            dataType: 'json',
            complete: function (response) {
                if (response.responseText) {
                    $(container).find('.phone_block_wrapper').find('.login_loader').addClass('nod');
                    try {
                        res = $.parseJSON(response.responseText);
                        cache[JSON.stringify(data)] = res;
                    } catch (err) {
                        res = { result: 1, message: 'Данные отправлены' };
                    }
                    updateForms(res);
                }
            },
            cache: false,
            async: true,
        };
        const testCache = cache[JSON.stringify(data)];
        if (testCache !== undefined) {
            ajax_obj.beforeSend();
            $(container).find('.phone_block_wrapper').find('.login_loader').addClass('nod');
            updateForms(testCache);
        } else {
            $.ajax(ajax_obj);
        }
    }
}

function send_prolong_as_sub(elem) {
    if (elem) {
        var error = 0;
        if (!$(elem).find('.prolong_sub_agreed').prop('checked')) {
            $(elem).find('.prolong_sub_agreed').parent().find('span').addClass('is-error');
            error = 1;
        }

        if (error == 0) {
            var service_id = $(elem).find('input[name="service_id"]').val();
            if ($('.popup-tarif-changed_' + service_id).is(':hidden')) {
                error = 1;
                $('.popup-tarif-changed_' + service_id).show();
            }
        }

        if (error == 0) {
            $('.popup-tarif-changed_' + service_id).hide();
            data = new Object;
            $(elem).find('.add_field').each(function () {
                data[$(this).attr('name')] = $(this).val();
            });
            var ajax_obj = {
                url: '/profile/orders/send_prolong_as_sub/',
                type: 'post',
                beforeSend: function () {
                    $(elem).find('.send_loader').removeClass('nod');
                    $(elem).find('.submit_button').addClass('nod');
                },
                data: data,
                dataType: 'json',
                complete: function (data) {
                    $(elem).find('.result_wrapper').removeClass('nod').addClass('green').html('Заявка отправлена');
                    $(elem).find('.send_loader').addClass('nod');
                    //$(elem).find('.submit_button').removeClass('nod');

                    if (data.responseText) {
                        try {
                            res = $.parseJSON(data.responseText);
                        } catch (err) {
                            res = new Object();
                            res.result = 0;
                            res.message = 'Продление невозможно';
                        }

                        if (res.result == 0) {
                            if (res.message) {
                                $(elem).find('.result_wrapper').removeClass('nod').addClass('green').html(res.message);
                            }
                        }
                        if (res.result == 1) {
                            $(elem).find('.result_wrapper').removeClass('nod').addClass('green').html('Заявка отправлена');
                        }

                    }
                },
                cache: false,
                async: true,
            };

            $.ajax(ajax_obj);
        }
    }
    return false;
}


function send_prolong(elem) {
    if (elem) {
        data = new Object;
        $(elem).find('.add_field').each(function () {
            data[$(this).attr('name')] = $(this).val();
        });
        var ajax_obj = {
            url: '/profile/orders/send_prolong/',
            type: 'post',
            beforeSend: function () {
                $(elem).find('.send_loader').removeClass('nod');
                $(elem).find('.submit_button').addClass('nod');
            },
            data: data,
            dataType: 'json',
            complete: function (data) {
                $(elem).find('.result_wrapper').removeClass('nod').addClass('green').html('Заявка отправлена');
                $(elem).find('.send_loader').addClass('nod');
                //$(elem).find('.submit_button').removeClass('nod');

                if (data.responseText) {

                    try {
                        res = $.parseJSON(data.responseText);
                    } catch (err) {
                        res = new Object();
                        res.result = 0;
                        res.message = 'Продление невозможно';
                    }
                    if (res.result == 0) {
                        if ($res.message) {
                            $(elem).find('.result_wrapper').removeClass('nod').addClass('green').html($res.message);
                        }
                    }
                    if (res.result == 1) {
                        $(elem).find('.result_wrapper').removeClass('nod').addClass('green').html('Заявка отправлена');
                    }

                }
            },
            cache: false,
            async: true,
        };

        $.ajax(ajax_obj);
    }
    return false;
}

function check_prolong(elem) {
    if (elem) {
        var day = $(elem).val();
        day = parseInt(day);
        if (day < 1 || !day) {
            $(elem).val('')
        } else {
            $(elem).val(day);
            var wrapper = $(elem).parents('.my_days_wrapper');
            var form = $(elem).parents('.profile_prolong_form');
            $(form).find('.day_count').val(day);

            var data = new Object;
            data.days = day;
            data.service_id = $(elem).parents('.profile_prolong_form').find('[name="service_id"]').val();


            var ajax_obj = {
                url: '/profile/orders/check_prolong/',
                type: 'post',
                beforeSend: function () {
                    $(wrapper).find('.myday').addClass('nod');
                    $(wrapper).find('.myday_all').addClass('nod');
                    $(wrapper).find('.loader_wrapper').removeClass('nod');
                },
                data: data,
                dataType: 'json',
                complete: function (data) {
                    $(wrapper).find('.myday').removeClass('nod');
                    $(wrapper).find('.myday_all').removeClass('nod');
                    $(wrapper).find('.loader_wrapper').addClass('nod');

                    if (data.responseText) {

                        try {
                            res = $.parseJSON(data.responseText);
                        } catch (err) {
                            res = new Object();
                            res.result = 0;
                            res.message = 'Продление невозможно';
                        }

                        if (res.myday) {
                            $(wrapper).find('.myday').html(res.myday);
                        }
                        if (res.myday_all) {
                            $(wrapper).find('.myday_all').html(res.myday_all);
                        }
                    }
                },
                cache: false,
                async: true,
            };

            $.ajax(ajax_obj);
        }

    }
}

function check_order_stop_form(elem) {
    if (elem) {
        var error = 0;
        var data = new Object;
        $(elem).find('.common_field_wrapper').find('.add_field').each(function () {
            data[$(this).attr('name')] = $(this).val();
        });
        data.new_address = $(elem).find('.new_address').val();
        var need_block = '.old_contact';
        if (data.new_address == 1) {
            need_block = '.new_contact';
        }
        $(elem).find(need_block).find('.add_field').each(function () {
            data[$(this).attr('name')] = $(this).val();
            if ($(this).hasClass('need_field') && !check_field($(this), 1)) {
                error = 1;
            }
        });

        if (error == 1) {
            go_to_error();
        }
        if (error == 0) {

            var ajax_obj = {
                url: $(elem).attr('action'),
                type: 'post',
                beforeSend: function () {
                    $(elem).find('.result_wrapper').addClass('nod');
                    $(elem).find('.result_wrapper').html('');
                    $(elem).find('.result_wrapper').removeClass('error-color');
                    $(elem).find('.result_wrapper').removeClass('green');
                    $(elem).find('.field_wrapper').addClass('nod');
                    $(elem).find('.loader_wrapper').removeClass('nod');
                },
                data: data,
                dataType: 'json',
                complete: function (data) {
                    $(elem).find('.loader_wrapper').addClass('nod');
                    $(elem).find('.result_wrapper').removeClass('nod');
                    //$(elem).find('.field_wrapper').removeClass('nod');


                    if (data.responseText) {

                        try {
                            res = $.parseJSON(data.responseText);
                        } catch (err) {

                            res = new Object();
                            res.result = 1;
                            res.message = 'Данные отправлены';
                        }

                        if (res.send.error) {
                            res.error = res.send.error;
                        }
                        if (res.error) {
                            res.result = 0;
                            console.log(res.error);
                            for (i = 0; i < res.error.length; i++) {
                                if (res.error[i].field != 'hidden') {
                                    $(elem).find('input[name=' + res.error[i].field + ']').addClass('is-error');
                                }
                            }
                            go_to_error();
                        }

                        if (res.result == 0) {
                            if (res.message) {
                                $(elem).find('.result_wrapper').removeClass('nod').addClass('green').html(res.message);
                            }
                        }
                        if (res.result == 1) {
                            $(elem).find('.close_button').click();
                            //$(elem).find('.result_wrapper').removeClass('nod').addClass('green').html('Заявка на возврат отправлена.Наши менеджеры свяжутся с Вами в ближайшее время');
                        }
                        if (res.send.error) {

                            $(elem).find('.result_message_button').find('textarea[name="message"]').text('Ошибка: ' + res.send.error);

                        }
                        $(elem).find('.result_message_button').click();
                        $(elem).find('.close_button').click();

                    }
                },
                cache: false,
                async: true,
            };

        }
        $.ajax(ajax_obj);

    }
    return false;
}

function check_default_address(elem) {
    if (elem) {
        if ($(elem).find('input[type="checkbox"]').prop('checked')) {
            $('.default_address').find('input[type="checkbox"]').prop('checked', false);
            $(elem).find('input[type="checkbox"]').prop('checked', true);
        }
    }
}

